/**
 * The filled play triangle on the Treinar button. Lucide's `Play` is an
 * outline, and A2 filled it with `fill="currentColor" strokeWidth={0}`; the
 * `<Icon>` wrapper fixes the stroke and never fills (plan D05), so the one
 * filled glyph in the shell is drawn here, in lucide's own 24 px geometry.
 * The colour is the button's text colour (`a-primary` sets `on-accent`).
 */
export function PlayGlyph({ className }: { className?: string }) {
  return (
    <svg
      aria-hidden="true"
      className={className}
      fill="currentColor"
      focusable="false"
      viewBox="0 0 24 24"
    >
      <path d="M5 5a2 2 0 0 1 3.008-1.728l11.997 6.998a2 2 0 0 1 .003 3.458l-12 7A2 2 0 0 1 5 19z" />
    </svg>
  );
}
